import { useCallback, useState, useEffect } from 'react'
import {
	Grid,
	CardContent,
	Card,
	Typography,
	ButtonGroup,
	IconButton,
	Divider,
	CardMedia,
} from '@mui/material'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import { useDropzone } from 'react-dropzone'
import { confirmAlert } from '../util/util'
import { LoaderContainer, LoaderIcon } from './ApplicationStyles'
import {
	apiFileDelete,
	apiFileDownloadByFileName,
	apiFileUpload,
} from 'api/api'
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import { FileItemType } from 'constants/types'
import DescriptionIcon from '@mui/icons-material/Description'
type ChildProps = {
	filePosition: string
	orderNo: number
	fileType: {} // { 'application/pdf': [] } 와 같은 형태로 입력
	isMultiple: boolean
	fileList: FileItemType[]
	setFileList: React.Dispatch<React.SetStateAction<FileItemType[]>>
}

const FileUploader: React.FC<ChildProps> = ({
	filePosition,
	orderNo,
	fileType,
	isMultiple,
	fileList,
	setFileList,
}) => {
	const [isLoading, setIsLoading] = useState<boolean>(false)

	const onDrop = useCallback((acceptedFiles: File[]) => {
		uploadAction(acceptedFiles)
	}, [])

	// 첨부파일 업로드
	const uploadAction = (files: File[]) => {
		setIsLoading(true)
		apiFileUpload(files[0], filePosition, orderNo)
			.then((res) => {
				console.log(res)
				setFileList((fileList) => [...fileList, ...res])
			})
			.finally(() => {
				setIsLoading(false)
			})
	}

	// 첨부파일 삭제
	const deleteAction = (storedFileName: string) => {
		confirmAlert(
			'삭제하시겠습니까?',
			() => {
				setIsLoading(true)
				apiFileDelete(storedFileName)
					.then((res) => {
						setFileList((fileList) =>
							fileList.filter((file) => file.storedFileName !== storedFileName)
						)
					})
					.finally(() => {
						setIsLoading(false)
					})
			},
			() => {}
		)
	}

	// 첨부파일 handler
	const { getRootProps, getInputProps, isDragActive, isDragReject } =
		useDropzone({
			onDrop: onDrop,
			accept: fileType,
			multiple: isMultiple,
		})

	const viewImage = (fileName: string) => {
		let imageWindow = window.open(``, 'image')
		imageWindow?.document.write(
			`<html><body><img src=${process.env.REACT_APP_HOST}/common/file/view/${fileName} alt='' /></body></html>`
		)
	}

	useEffect(() => {
		// setFileList(attachFileList)
	}, [])

	return (
		<Grid
			container
			spacing={1}
		>
			<Grid size={12}>
				{isLoading && (
					<LoaderContainer>
						<LoaderIcon />
					</LoaderContainer>
				)}
				<div
					className="dropzone dz-clickable dz-started"
					{...getRootProps()}
				>
					<input {...getInputProps()} />
					{!isDragActive && (
						<Card sx={{ backgroundColor: '#121212' }}>
							<CardContent sx={{ paddingBottom: '16px !important' }}>
								<Typography
									color="#fff"
									variant="body1"
									component="p"
									sx={{ marginBottom: '0' }}
								>
									<AttachFileIcon
										fontSize="small"
										sx={{ marginBottom: '0' }}
									/>{' '}
									파일을 선택하세요.
								</Typography>
							</CardContent>
						</Card>
					)}
					{isDragReject && <p className="text-warning">지원하지 않는 파일입니다.</p>}
				</div>
			</Grid>
			<Grid size={12}>
				<div
					className="dz-preview dz-processing dz-image-preview dz-success dz-complete"
					style={{ marginTop: '1rem' }}
				>
					<div className="dz-details">
						<div className="dz-filename">
							<Grid
								container
								spacing={2}
							>
								{fileList.map((fileItem: FileItemType) => (
									<Grid
										size={{ xs: 6, md: 3, lg: 2 }}
										key={fileItem.id}
									>
										<Card sx={{ maxWidth: '100%' }}>
											{fileItem.contentType.startsWith('image') ? (
												<CardMedia
													sx={{ height: 150, width: '100%' }}
													image={`${process.env.REACT_APP_HOST}/common/file/view/${fileItem.storedFileName}`}
													title={fileItem.storedFileName}
													onClick={() => viewImage(fileItem.storedFileName)}
													style={{ cursor: 'pointer' }}
												/>
											) : (
												<>
													{/* 이미지가 아닐 경우 아이콘 표기 */}
													<div style={{ height: '150px' }}>
														<DescriptionIcon />
													</div>
												</>
											)}
											<CardContent sx={{ display: 'flex', flexDirection: 'column' }}>
												<Typography
													gutterBottom
													variant="body2"
													component="p"
													sx={{
														WebkitLineClamp: '1',
														textOverflow: 'ellipsis',
														display: '-webkit-box',
														WebkitBoxOrient: 'vertical',
														overflow: 'hidden',
													}}
												>
													{fileItem.originalFileName}
												</Typography>
												<ButtonGroup
													variant="text"
													aria-label="text button group"
												>
													<IconButton
														color="primary"
														size="small"
														onClick={() =>
															apiFileDownloadByFileName(
																fileItem.storedFileName,
																fileItem.originalFileName
															)
														}
													>
														<DownloadForOfflineIcon />
													</IconButton>
													<IconButton
														color="error"
														size="small"
														onClick={() => deleteAction(fileItem.storedFileName)}
													>
														<DeleteForeverIcon />
													</IconButton>
												</ButtonGroup>
											</CardContent>
										</Card>
									</Grid>
								))}
							</Grid>
						</div>
					</div>
					<div className="dz-progress">
						<span
							className="dz-upload"
							data-dz-uploadprogress=""
							style={{ width: '100%' }}
						></span>
					</div>
				</div>
			</Grid>
		</Grid>
	)
}

export default FileUploader
